module.exports = __webpack_public_path__ + "img/jacobus_02.1aca6797.png";